import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HelperNavigationModule } from '@core/components/helpers/navigation/navigation.module';
import { HelperIconsModule } from '@core/components/helpers/icons/icons.module';
import { PreviewModule } from '@core/components/preview/preview.module';
import { StoragePreviewModule } from '@core/components/storage-preview/storage-preview.module';

import { FilesListDefaultItemComponent } from './default-item/default-item.component';
import { FilesListDefaultComponent } from './default/default.component';
import { FilesListNotesItemComponent } from './notes-item/notes-item.component';
import { FilesListNotesComponent } from './notes/notes.component';
import { FilesListsNotesGridItemComponent } from './notes-grid-item/notes-grid-item.component';
import { FilesListItemComponent } from './item/item.component';

@NgModule({
    imports: [
        CommonModule,
        HelperNavigationModule,
        HelperIconsModule,
        PreviewModule,
        StoragePreviewModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    declarations: [
        FilesListDefaultItemComponent,
        FilesListDefaultComponent,
        FilesListNotesComponent,
        FilesListNotesItemComponent,
        FilesListsNotesGridItemComponent,
        FilesListItemComponent
    ],
    exports: [
        FilesListDefaultItemComponent,
        FilesListDefaultComponent,
        FilesListNotesComponent,
        FilesListNotesItemComponent,
        FilesListsNotesGridItemComponent,
        FilesListItemComponent
    ],

})
export class FilesListModule { }
